import { render, staticRenderFns } from "./BookingHotelDataTable.vue?vue&type=template&id=270318d3&scoped=true&"
import script from "./BookingHotelDataTable.vue?vue&type=script&lang=js&"
export * from "./BookingHotelDataTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "270318d3",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VChip,VDataTable,VIcon,VTooltip})


/* hot reload */
if (module.hot) {
  var api = require("/srv/dev/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('270318d3')) {
      api.createRecord('270318d3', component.options)
    } else {
      api.reload('270318d3', component.options)
    }
    module.hot.accept("./BookingHotelDataTable.vue?vue&type=template&id=270318d3&scoped=true&", function () {
      api.rerender('270318d3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Booking/BookingHotelDataTable.vue"
export default component.exports